import Konva from 'konva';
import { colors } from './addScaleBar';

export function createLegendTop(): Konva.Text {
  return new Konva.Text({
    x: 8,
    offsetY: 12,
    fontFamily: 'Lato',
    fontSize: 10,
    fontStyle: 'bold',
    fill: colors.black,
  });
}
